import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { AvailableStockCountLabel } from './AvailableStockCountLabel';

type FloatingAddToCartComponentProps = {
	lineOfProduct: string;
	strikePrice: string;
	discountPercentage?: string;
	productTitle: string;
	productPrice: string;
	currentTenure: number;
	isAvailable: boolean;
	availableUnits: number;
	CartActionButton: JSX.Element;
};

const ConditionTextMapper = {
	RENT: 'RENT',
	BUY_NEW: 'BUY NEW',
	BUY_REFURBISHED: 'BUY REFURBISHED',
};

const FloatingAddToCartComponent = (props: FloatingAddToCartComponentProps) => {
	const bgColor = props.lineOfProduct == 'RENT' ? 'Orange -5' : 'Navy -5';
	return (
		<Box
			sx={{
				position: 'sticky',
				bottom: '0',
				width: '100%',
				paddingLeft: '16px',
				zIndex: 9,
			}}
		>
			<FlexBox
				sx={{
					boxShadow: '0px 0px 32px rgba(34, 34, 34, 0.2)',
					background: getColor(`${bgColor}`),
					padding: '8px 24px 8px 24px',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<FlexBox direction='column'>
					<LencoTypography
						sx={{ ...getStyle('Small_Medium'), color: getColor('Gray -3') }}
					>
						{
							ConditionTextMapper[
								props.lineOfProduct as keyof typeof ConditionTextMapper
							]
						}
					</LencoTypography>
					<LencoTypography
						sx={{
							...getStyle('H9A_Medium'),
							color: getColor('Gray 0'),
							maxWidth: '100%',
						}}
					>
						{props?.productTitle}
					</LencoTypography>
				</FlexBox>
				<FlexBox sx={{ alignItems: 'center', paddingLeft: '16px' }}>
					<LencoTypography
						sx={{
							...getStyle('Small_Regular'),
							textDecoration: 'line-through',
							color: getColor('Gray -2'),
						}}
					>
						{props.strikePrice}
					</LencoTypography>
					<LencoTypography
						sx={{
							...getStyle('P_SemiBold'),
							color: getColor('Gray 0'),
							paddingLeft: '8px',
							paddingRight: '16px',
							whiteSpace: 'nowrap',
						}}
					>
						{`${props?.discountPercentage} OFF`}
					</LencoTypography>
					<Box>{props.CartActionButton}</Box>
				</FlexBox>
			</FlexBox>
		</Box>
	);
};

export default FloatingAddToCartComponent;
